import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import type { Middleware } from 'redux';

import middleware from '@/shared/redux/middleware';
import rootReducer from '@/shared/redux/reducers/index';

const ReduxStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(...(middleware as Middleware[]))
});

export default ReduxStore;
